import DOMPurify from 'dompurify';
import { secretFieldPlugin } from './plugins/secretFieldPlugin';
import { createMarkdownRenderer } from './createMarkdownRenderer';

const md = createMarkdownRenderer();

// Add support for secret fields in preview
md.use(secretFieldPlugin);

/**
 * Safely converts markdown to sanitized HTML
 * @param markdown - The markdown string to convert
 * @returns Sanitized HTML string
 */
export function renderMarkdownSafe(markdown: string): string {
  if (!markdown) {
    return '';
  }

  // Render markdown to HTML
  const dirty = md.render(markdown);

  // Sanitize the HTML to prevent XSS attacks
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 'code', 'pre', 'a',
      'ul', 'ol', 'li', 'blockquote',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'input',   // task list checkboxes
      'label',   // task list labels
      'div',     // secret field blocks
      'span',    // secret field inline / labels
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel',
      'class',
      'type', 'checked', 'disabled',
    ],
    // SVG needs explicit opt-in — DOMPurify strips it from the HTML namespace
    // even when listed in ALLOWED_TAGS.
    ADD_TAGS: ['svg', 'path'],
    ADD_ATTR: ['viewBox', 'fill', 'd', 'width', 'height'],
  });
}
